import { CANDY_APPLE, CHART_YELLOW, EERIE, OZ, SORBET } from 'HubStyleTokens/colors';
export const HEALTH_METRICS = {
  OPEN: 'open',
  CLICK_THROUGH: 'clickToOpen',
  HARD_BOUNCE: 'hardBounce',
  UNSUBSCRIBE: 'unsubscribe'
};
export const CONDITIONAL_HEALTH_METRICS = {
  SPAM_REPORT: 'spamReport'
};
export const OVER_TIME = 'overTime';
export const HEALTH_BUCKETS = {
  NOT_ENOUGH_DATA: 'NOT_ENOUGH_DATA',
  POOR: 'POOR',
  NEEDS_WORK: 'NEEDS_WORK',
  OKAY: 'OKAY',
  GOOD: 'GOOD',
  VERY_GOOD: 'VERY_GOOD',
  EXCELLENT: 'EXCELLENT'
};
export const HEALTH_METRICS_PRECISION_MAP = {
  [HEALTH_METRICS.OPEN]: 1,
  [HEALTH_METRICS.CLICK_THROUGH]: 1,
  [HEALTH_METRICS.HARD_BOUNCE]: 2,
  [HEALTH_METRICS.UNSUBSCRIBE]: 2
};
export const HEALTH_METRICS_LIST = [HEALTH_METRICS.OPEN, HEALTH_METRICS.CLICK_THROUGH, HEALTH_METRICS.HARD_BOUNCE, HEALTH_METRICS.UNSUBSCRIBE];
export const MINIMUM_SENT_COUNT_REQUIRED_FOR_HS = {
  DEFAULT: 400,
  FILTER: 250
};
export const HEALTH_BUCKET_COLOR_MAP = {
  NOT_ENOUGH_DATA: EERIE,
  POOR: CANDY_APPLE,
  NEEDS_WORK: SORBET,
  OKAY: CHART_YELLOW,
  GOOD: OZ,
  VERY_GOOD: OZ,
  EXCELLENT: OZ
};
export const HEALTH_BUCKET_COLOR_TOKEN_MAP = {
  NOT_ENOUGH_DATA: 'icon-core-subtle',
  POOR: 'text-alert-default',
  NEEDS_WORK: 'fill-accent-light-orange-default',
  OKAY: 'do-not-use-chart-yellow',
  GOOD: 'text-positive-default',
  VERY_GOOD: 'text-positive-default',
  EXCELLENT: 'text-positive-default'
};
export const DEFAULT_BREAKDOWN = OVER_TIME;
export const HEALTH_TYPES = {
  NOT_ENOUGH_DATA: 'NOT_ENOUGH_DATA',
  GOOD: 'GOOD',
  OK: 'OK',
  BAD: 'BAD'
};
export const DATE_TYPES = {
  END: 'END',
  START: 'START',
  LAST_UPDATE: 'LAST_UPDATE',
  NEXT_UPDATE: 'NEXT_UPDATE'
};
export const TRACKING_INTERACTION_TYPES = {
  BREAKDOWN_PAGE_CHANGE: 'BREAKDOWN_PAGE_CHANGE',
  CLEAR_FILTER: 'CLEAR_FILTER',
  LINK_CLICK: 'LINK_CLICK',
  OVERALL_PAGE_CHANGE: 'OVERALL_PAGE_CHANGE',
  OVER_TIME_TOOLTIP_VIEW: 'OVER_TIME_TOOLTIP_VIEW',
  SELECT_FILTER: 'SELECT_FILTER',
  SET_FILTER: 'SET_FILTER',
  RECOMMENDATION_CLICK: 'RECOMMENDATION_CLICK',
  INDUSTRY_BANNER_SET: 'INDUSTRY_BANNER_SET',
  INDUSTRY_BANNER_DISMISS: 'INDUSTRY_BANNER_DISMISS',
  TOGGLE_HEALTH_SCORE_TYPE: 'TOGGLE_HEALTH_SCORE_TYPE',
  LOAD_HEALTH_SCORE_TYPE_SELECTION: 'LOAD_HEALTH_SCORE_TYPE_SELECTION',
  LOAD_HEALTH_TOOL: 'LOAD_HEALTH_TOOL'
};
export const HEALTH_STATUS = {
  SCORE_AVAILABLE: 'SCORE_AVAILABLE',
  SCORE_NOT_AVAILABLE: 'SCORE_NOT_AVAILABLE'
};
export const HEALTH_SCORE_TYPES = {
  GLOBAL: 'GLOBAL',
  INDUSTRY: 'INDUSTRY'
};